// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__80N6r","errors":"Errors_errors__1oyIx"};